import { c as _c } from "react/compiler-runtime";
import type { AuthorWithAvatarUrls } from '@cc-shopping/contracts/cross-site/author/transformAuthor';
import { SocialMediaLink } from '@cc-shopping/ui/composites/SocialMediaLink';
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, Link, type LinkProps, Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
const READ_FULL_PROFILE = 'Read full profile';
const IMAGE_SIZE = '55px';
function ImageLink(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "block",
      outline: "1px solid",
      outlineColor: "grey.200",
      borderRadius: "100%",
      width: IMAGE_SIZE,
      height: IMAGE_SIZE,
      "& img": {
        width: IMAGE_SIZE,
        height: IMAGE_SIZE
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <Link {...props} sx={t1}>{children}</Link>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function AuthorNameAndLinkContainer(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      flexGrow: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box sx={t1}>{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function SocialContainer(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      gap: "20px",
      padding: 0,
      margin: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box component="ul" sx={t1}>{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function SocialListItem(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      listStyle: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box component="li" sx={t1}>{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export interface AuthorCardProps {
  author: AuthorWithAvatarUrls;
  avatar: {
    width: number;
    height: number;
    url: string;
  };
  fromReview?: boolean;
}
export default function AuthorCard(t0) {
  const $ = _c(40);
  const {
    author: t1,
    avatar,
    fromReview: t2
  } = t0;
  const {
    name: authorName,
    bio,
    link: fullPageUrl,
    socialMediaLinks,
    userPage
  } = t1;
  const fromReview = t2 === undefined ? false : t2;
  if (!authorName || !fullPageUrl) {
    return null;
  }
  const showBio = bio && !fromReview;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderRadius: "inherit"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== avatar.height || $[2] !== avatar.url || $[3] !== avatar.width) {
    t4 = <CdnImage width={avatar.width} height={avatar.height} src={avatar.url} alt="Portrait of author" style={t3} />;
    $[1] = avatar.height;
    $[2] = avatar.url;
    $[3] = avatar.width;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== fullPageUrl || $[6] !== t4) {
    t5 = <ImageLink href={fullPageUrl}>{t4}</ImageLink>;
    $[5] = fullPageUrl;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      display: "flex",
      flexDirection: "column"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      margin: 0
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== authorName || $[11] !== fullPageUrl) {
    t8 = <Typography component="h3" fontSize="1.2rem" fontWeight="bold" sx={t7}><Link href={fullPageUrl} color="black">{authorName}</Link></Typography>;
    $[10] = authorName;
    $[11] = fullPageUrl;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== userPage) {
    t9 = userPage?.jobTitle && <Typography variant="textExtraSmall" color="text.secondary" lineHeight="13px">{userPage.jobTitle}</Typography>;
    $[13] = userPage;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Box sx={t6}>{t8}{t9}</Box>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== bio || $[19] !== showBio) {
    t11 = showBio && <Typography variant="text" sx={{
      display: "-webkit-box",
      overflow: "hidden",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 4,
      marginBottom: 1
    }}>{bio}</Typography>;
    $[18] = bio;
    $[19] = showBio;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      display: "flex",
      justifyContent: "space-between"
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== socialMediaLinks) {
    t13 = socialMediaLinks.map(_temp);
    $[22] = socialMediaLinks;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13) {
    t14 = <SocialContainer>{t13}</SocialContainer>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== authorName || $[27] !== fullPageUrl || $[28] !== showBio) {
    t15 = showBio && <Link href={fullPageUrl} aria-label={`${READ_FULL_PROFILE} for ${authorName}`}>{READ_FULL_PROFILE}</Link>;
    $[26] = authorName;
    $[27] = fullPageUrl;
    $[28] = showBio;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15) {
    t16 = <Box sx={t12}>{t14}{t15}</Box>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t16) {
    t17 = <AuthorNameAndLinkContainer>{t10}{t11}{t16}</AuthorNameAndLinkContainer>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t5) {
    t18 = <Box display="flex" gap="20px" alignItems="start">{t5}{t17}</Box>;
    $[37] = t17;
    $[38] = t5;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}
function _temp(socialMedia) {
  return <SocialListItem key={socialMedia.url}><SocialMediaLink type={socialMedia.type} url={socialMedia.url} iconOnly={true} /></SocialListItem>;
}